import '../../../services/interface/methods.js';
import { magic } from '@gig/magic-sdk';
import '../../../services/wallet.service.js';
import { paymentService } from '../../../services/payment/payment.service.js';
import '../../../services/payment/payment.interface.js';
import '../../../services/interface/events.js';
import { SET_PAYMENT_PROCESSING, SET_PAYMENT_ERROR_STATUS_CODE, SET_PAYMENT_RESULT, IPaymentResult, SET_SAVED_CARDS, SET_SAVED_CARDS_INITIALISED } from './quick-deposit.constants.js';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const getters = {
  savedCards(state) {
    return state.savedCards;
  },
  paymentProcessing(state) {
    return state.paymentProcessing;
  },
  paymentResult(state) {
    return state.paymentResult;
  },
  paymentErrorStatusCode(state) {
    return state.paymentErrorStatusCode;
  }
};
let unsub;
const actions = {
  initSavedCards(_0) {
    return __async(this, arguments, function* ({
      commit,
      state
    }) {
      if (state.initialised) {
        return;
      }
      if (unsub) {
        unsub();
      }
      try {
        const savedCards = yield paymentService.getCreditCards();
        commit(SET_SAVED_CARDS, savedCards);
        commit(SET_SAVED_CARDS_INITIALISED, true);
        unsub = magic.events.sessionDestroyed(() => {
          commit(SET_SAVED_CARDS, []);
          commit(SET_SAVED_CARDS_INITIALISED, false);
        }).unsub;
      } catch (e) {
        console.error(e);
      }
    });
  },
  deposit(_0, _1) {
    return __async(this, arguments, function* ({ commit, state }, {
      selectedCard,
      amount,
      cvv,
      device,
      service
    }) {
      var _a;
      const result = {};
      try {
        const card = state.savedCards.find((card2) => card2.value === selectedCard);
        if (!card) {
          return result;
        }
        commit(SET_PAYMENT_PROCESSING, true);
        const response = yield paymentService.quickDeposit({
          card,
          amount,
          cvv,
          device,
          service
        });
        const { success, redirectOutput, errors = [] } = response;
        const maskedAccount = response.maskedAccount || card.maskedAccount;
        if (!success) {
          commit(SET_PAYMENT_ERROR_STATUS_CODE, (_a = response == null ? void 0 : response.statusCode) != null ? _a : null);
          throw new Error(errors.map((field, msg) => `${field}: ${msg}`).join("\n"));
        }
        if (redirectOutput && maskedAccount) {
          result.resumeDeposit = {
            amount,
            cardType: card.type,
            maskedAccount,
            redirectOutput
          };
        } else {
          commit(SET_PAYMENT_RESULT, IPaymentResult.SUCCESS);
        }
      } catch (e) {
        commit(SET_PAYMENT_RESULT, IPaymentResult.ERROR);
        console.error(e);
      } finally {
        setTimeout(() => {
          commit(SET_PAYMENT_RESULT, IPaymentResult.INITIAL);
        }, 3e3);
        commit(SET_PAYMENT_PROCESSING, false);
      }
      return result;
    });
  }
};
const quickDeposit = {
  namespaced: true,
  state: {
    savedCards: [],
    initialised: false,
    paymentProcessing: false,
    paymentResult: IPaymentResult.INITIAL,
    paymentErrorStatusCode: null
  },
  getters,
  actions,
  mutations: {
    [SET_SAVED_CARDS](state, payload) {
      state.savedCards = payload;
    },
    [SET_SAVED_CARDS_INITIALISED](state, payload) {
      state.initialised = payload;
    },
    [SET_PAYMENT_PROCESSING](state, payload) {
      state.paymentProcessing = payload;
    },
    [SET_PAYMENT_RESULT](state, payload) {
      state.paymentResult = payload;
    },
    [SET_PAYMENT_ERROR_STATUS_CODE](state, payload) {
      state.paymentErrorStatusCode = payload;
    }
  }
};

export { actions, getters, quickDeposit };
